import { env } from "@beztack/env/ui";

export type ReverseGeocodeResult = {
  displayName: string | null;
  line1: string | null;
  line2: string | null;
  city: string | null;
  country: string | null;
};

// Issue #71: callers may pass an `AbortSignal` so pin-movement debounce
// can cancel an inflight reverse-resolution when the customer drags the
// pin again before the previous request finishes. We deliberately do NOT
// surface AbortError to the caller — checkout treats it as a no-op so
// the cancelled fetch is indistinguishable from a fast follow-up.
export async function reverseGeocode(
  lat: number,
  lng: number,
  signal?: AbortSignal,
): Promise<ReverseGeocodeResult> {
  const base = env.VITE_API_URL.replace(/\/$/, "");
  const url = `${base}/api/maps/reverse-geocode?lat=${lat}&lng=${lng}`;

  const response = await fetch(url, {
    credentials: "include",
    signal,
  });

  if (!response.ok) {
    throw new Error(`Reverse geocode failed (${response.status})`);
  }

  return (await response.json()) as ReverseGeocodeResult;
}
